module.exports = __webpack_public_path__ + "img/magento_1.ed8bab07.png";